// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"18d9aed1","455":"6a27b3cb","977":"bd4bc761"}[chunkId] + ".chunk.js";
};